<template>
  <div class="row justify-content-center">
    <transition v-bind:name="transitionName" mode='out-in'>
      <component  class="form-container" :is='currentStepComponent'  @loading-toggle="handleLoadingToggle"></component>
    </transition>
  </div>
</template>

<style lang="scss" scoped>
  .form-container {
    display: inline-block;
    width: 100%;
  }
</style>

<script>
import steps from '@/components/AdditionalInformationPeerToPeer'
import StepBackButton from '@/components/StepBackButton'

let components = Object.assign({StepBackButton}, steps)
 
export default {
  data() {
    return {
      transitionName: 'slide-left'
    }
  },
  components: components,
  computed: {
    currentStepComponent: function() {
      return'finished-step'
    },
    progress: function() {
      return 100
    }
  },
  methods: {
    
  },
  beforeCreate() {
   
     
  },
  beforeUpdate() {
    this.$Loading.update(this.progress)
  }
}
</script>



// WEBPACK FOOTER //
// src/views/AdditionalInformationConstrucao.vue